import React, { Component } from 'react';
import AnalogClock from './AnalogClock';

class AnalogClockCurrentTime extends Component {
    state = {
        secondRatio: 0,
        minuteRatio: 0,
        hourRatio: 0
    }
    componentDidMount () {
        setInterval(() => {
            this.setClock()
        }, 1000);
    }
    setClock = () =>{    
        const currentDate = new Date();
        let secondRatio = currentDate.getSeconds() / 60;
        let minuteRatio = (secondRatio + currentDate.getMinutes()) / 60;
        let hourRatio = (minuteRatio + currentDate.getHours()) / 12;
        this.setState({secondRatio}) 
        this.setState({minuteRatio}) 
        this.setState({hourRatio});
    }

    render(){
        const {secondRatio, minuteRatio, hourRatio} = this.state
        return (
            <AnalogClock secondRatio={secondRatio} minuteRatio={minuteRatio} hourRatio={hourRatio}/>
        );
    }
}
export default AnalogClockCurrentTime;

// import AnalogClock from 'analog-clock-react';
   
// export default function AnalogClockCurrentTime() {
//   let options = {
//     width: "300px",
//     border: true,
//     borderColor: "#2e2e2e",
//     baseColor: "#17a2b8",
//     centerColor: "#459cff",
//     centerBorderColor: "#ffffff",
//     handColors: {
//       second: "#d81c7a",
//       minute: "#ffffff",
//       hour: "#ffffff"
//     }
//   };
   
//   return (
//     <div>
//       <center>
//         <h2>Clock</h2>
//         <AnalogClock {...options} />
//       </center>
//     </div>
//   )
// }
